const INTEGRATION_STATUS_DICT = {
  active: 'active',
  not_active: 'not active',
  in_progress: 'in progress',
  pending: 'pending',
} as const;

export default INTEGRATION_STATUS_DICT;
